import React from 'react';
import { Instagram, Facebook } from 'lucide-react';

interface SocialIconsProps {
  className?: string;
  iconSize?: number;
  showText?: boolean;
}

export default function SocialIcons({ className = '', iconSize = 5, showText = false }: SocialIconsProps) {
  const socialLinks = [
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/laetitia5514?utm_source=qr&igsh=Zmhzd3hmc2N1cno=',
      icon: Instagram,
      color: 'text-white hover:text-pink-400 dark:text-white dark:hover:text-pink-400'
    },
    {
      name: 'Facebook',
      url: 'https://www.facebook.com/share/1T7GV6h5Tc',
      icon: Facebook,
      color: 'text-white hover:text-blue-400 dark:text-white dark:hover:text-blue-400'
    }
  ];

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`flex items-center gap-2 ${social.color} transition-colors`}
          aria-label={`Follow us on ${social.name}`}
        >
          <social.icon className={`w-${iconSize} h-${iconSize}`} />
          {showText && <span>{social.name}</span>}
        </a>
      ))}
    </div>
  );
}